module.exports = __webpack_public_path__ + "static/019-5219804a212f269e85b05453fe7bec23.png";